import { Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const LeadCreation = (props) => {
  const PROFILE_ID = props?.urlparams?.params?.profileId;
  const [isValid, setIsValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });
  const [profileDetails, setProfileDetails] = useState({});
  const [isformSubmitted, setIsformSubmitted] = useState(false);
  const [fields, setFields] = useState([
    {
      name: "leadName",
      label: "Name",
      type: "text",
      required: true,
    },
    {
      name: "mobileNumber",
      label: "Mobile No.",
      type: "text",
      required: true,
      onChange: (...args) => handleMobileNo(...args),
    },
    {
      name: "loanAmount",
      label: "Loan Amount",
      type: "number",
    },
    {
      name: "productType",
      label: "Product Type",
      type: "select",
      options: [],
      required: true,
    },
  ]);

  const handleMobileNo = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue) && fieldValue.length === 10) {
      setErrorMessage({ name: "", message: "" });
    } else {
      setErrorMessage({
        name: "mobileNumber",
        message: "Please enter a valid Mobile Number",
      });
    }
  };

  const getProductTypes = () => {
    props.apis.apiGetProductTypes().then((res) => {
      let productType = fields.find((o) => o.name == "productType");
      productType.options = [...res, { key: "other", label: "Others" }];

      setFields([...fields]);
    });
  };

  const getProfileDetails = () => {
    let payload = {
      profileId: PROFILE_ID,
    };
    props.apis.apiGetDigirepOpen(payload).then((res) => {
      setProfileDetails(res);
    });
  };

  const handleAcknowledge = (e) => {
    let value = e.target.checked;
    console.log({ value });

    setIsValid(!value);
  };

  const handleSubmit = (e, data) => {
    let urldata = {
      profileId: PROFILE_ID,
    };
    let payload = {
      ...data,
      loanAmount: Number(data?.loanAmount),
      status: "OPEN",
    };
    let cleanedPayload = Object.removeEmptyProps(payload);
    props.apis
      .apiAddApplicationViaQrcode(urldata, cleanedPayload)
      .then((res) => {
        setIsformSubmitted(true);
        sessionStorage.setItem("isFormSubmitted", true);
      });
  };

  const handleSiteRedirection = (e) => {
    e.preventDefault();
    window.location.replace("https://www.starpowerzdigiloans.com/");
  };

  useEffect(() => {
    getProductTypes();
    getProfileDetails();

    let isFormSubmitted = sessionStorage.getItem("isFormSubmitted");
    if (isFormSubmitted) {
      setIsformSubmitted(true);
    }
  }, []);

  return (
    <>
      <div className="page-wraper AppLeadCreation">
        <div
          className={Object.className({
            "row gx-0": true,
            "height-full": isformSubmitted,
          })}
        >
          <div className="col-12">
            <div className="logo_header p-3 mb-5">
              <Link to={"/open/login"} className="logo">
                <img src={imagepaths.logoWithTaglineDark} alt="logo" />
              </Link>
            </div>
            <div className="container lead_creation_form_container">
              <h1>
                <span>Find the </span>
                <span className="yellow">Right Loan </span>
                <span>for Every Need</span>
              </h1>
              <div className="card lead_form_card my-4">
                <div className="card-header">
                  <table>
                    <tbody>
                      <tr>
                        <td>Digirep Name</td>
                        <td>:</td>
                        <td>{profileDetails?.name || "-"}</td>
                      </tr>
                      <tr>
                        <td>Digirep ID</td>
                        <td>:</td>
                        <td>{profileDetails?.profileId || "-"}</td>
                      </tr>
                      <tr>
                        <td>Mobile No.</td>
                        <td>:</td>
                        <td>{profileDetails?.mobileNumber || "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="card-body">
                  {isformSubmitted ? (
                    <div className="text-center">
                      <h2>Lead submitted successfully</h2>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={(e) => handleSiteRedirection(e)}
                      >
                        Back To Home
                      </button>
                    </div>
                  ) : (
                    <>
                      <h2>Apply for Loan</h2>

                      <AppForm onSubmit={handleSubmit}>
                        {fields?.map((field, i) => {
                          return (
                            <div
                              className={`col-12 col-md-${
                                field?.customcolspan || 5
                              }`}
                              key={i}
                            >
                              <AppInput {...field}></AppInput>
                              {errorMessage &&
                                errorMessage?.name === field?.name && (
                                  <span className="text-danger">
                                    {errorMessage?.message}
                                  </span>
                                )}
                            </div>
                          );
                        })}
                        <div className="col-12 acknowledgement">
                          <Checkbox
                            onChange={(...args) => handleAcknowledge(...args)}
                            className="mb-4"
                          >
                            I consent to provide my information for contact
                            regarding loan offers and services, understanding my
                            data will remain confidential
                          </Checkbox>
                        </div>
                        <div className="col-12">
                          <button
                            type="submit"
                            className="btn btn-primary w-100"
                            disabled={isValid}
                          >
                            Submit
                          </button>
                        </div>
                      </AppForm>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(LeadCreation);
